import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Auth, signOut } from '@angular/fire/auth';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-dummy-vendor',
  standalone: true,
  templateUrl: './dummy-vendor.component.html',
  styleUrls: ['./dummy-vendor.component.scss'],
  imports: [CommonModule, MatIconModule]
})
export class DummyVendorComponent {

  constructor(
    private auth: Auth,
    private router: Router,
    private authService: AuthService
  ) {}

  showAccountMenu = false;

  toggleAccountMenu() {
    this.showAccountMenu = !this.showAccountMenu;
  }

  logout() {
    this.authService.userSignOut();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = (event.target as HTMLElement).closest('.account-btn, .account-dropdown');
    if (!clickedInside) {
      this.showAccountMenu = false;
    }
  }

}
